import React from 'react'
import { close_icon } from '../../assets/images'
import { Stepathon_modal_headers } from '../../constants/tableHeaders'
import { stepathonModelSchema } from '../../schemas/table'
import { Table } from '../../components/common/molecules'

const CreateOrUpdateModelStepathon = ({ visible, icon, text = 'create', subTitle='', btnText = 'Create stepathon', onCancel, data , handler = () => {},  ...props }) => {
  return (
    <div
    className={`fixed z-20 inset-0  overflow-y-auto ${visible ? '' : 'hidden'}`}
    aria-labelledby='modal-title'  
    aria-modal='true'
  >
    <div className='flex items-end justify-center pt-4 px-4  text-center sm:block '>
      <div
        className='fixed inset-0 bg-gray-900 bg-opacity-25 transition-opacity'
        aria-hidden='true'
        onClick={onCancel}
      > </div>

      <span className='sm:inline-block sm:align-middle sm:h-screen' aria-hidden='true'>
        &#8203;
      </span>

      <div 
        className='inline-block align-bottom bg-white rounded-lg text-left transform duration-75 sm:my-8 sm:align-middle sm:max-w-3xl sm:w-full'
       style ={{width : '720px'}}
      >

        <div className='flex flex-row-reverse pt-4 pr-4 '>
        <img src={close_icon} alt='closeIcon' className='cursor-pointer' onClick={onCancel} />
        </div>
        <div className='px-8'>
        <h3 className='text-xl leading-6 font-extrabold text-gray-700 mb-3' id='modal-title'>
           Are you sure you want to {text} stepathon ?
        </h3> 
        <p className='text-gray-600 text-base font-normal mb-6 mr-24'>{subTitle}</p>   
        <Table
        data={data}
        headers={Stepathon_modal_headers}
        tableschema={stepathonModelSchema}
        tableClasses='alternate_gray200_color'
        classes='rounded-md '
        />
        </div>
        <div className="bg-gray-100 px-8 mt-6 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
          <button type="button" className="w-full block justify-center rounded border border-transparent  px-6 py-3 bg-blue-600 text-base font-semibold text-white  focus:outline-none  sm:ml-3 sm:w-auto sm:text-sm" onClick={(e) => handler(e.target, data)}>{btnText}</button>
          <button type="button" className="mt-3 w-full block justify-center rounded border-none  px-6 py-3 text-base font-semibold text-blue-600  focus:outline-none    sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"  onClick={onCancel}>No, cancel</button>
        </div>
      </div>
    
    </div>
  </div>
   )
}

export default CreateOrUpdateModelStepathon